import React from "react";
import { setActions, setIsActionsClicked, setIsEdited } from "../../../store";
import { ConfirmationEditMessage } from "@components/Common/ConfirmationEditMessage";
import { ConfirmationModificationMessage } from "../../ConfirmationModificationMessage";
import { ConfirmationAssociationModal } from "../../ConfirmationAssociationModal";
import AdvancedDisplayNameModal from "@pages/SettingGeneral/DisplayName/AdvancedDisplayNameModal";
import { FormState } from "../useInformationFormReducer";

interface Props {
    form: FormState;
    // Edit confirmation
    isModalOpened: boolean;
    setIsModalOpened: (v: boolean) => void;
    setIsAddClicked: Function;
    setEditedData: Function;
    // Modification confirmation
    isModalOpen: boolean;
    setIsModalOpen: (v: boolean) => void;
    setDataIsUpdated: Function;
    dataModeInformation: any;
    associated: any[];
    setIsSendingTag: (v: boolean) => void;
    dataTable: any;
    setIsAddModeOfInformationClicked: Function;
    setLimit: Function;
    KIOSKData: any;
    // Association
    isModalModifiedOpened: boolean;
    setIsModalModifiedOpened: (v: boolean) => void;
    // Advanced display name
    isAdvancedDisplayNameModalOpen: boolean;
    setIsAdvancedDisplayNameModalOpen: (v: boolean) => void;
    setAdvancedDisplayName: (val: any) => void;
    language: string[];
    isConsult: boolean;
    isActionsClicked: boolean;
}

const InformationFormModals = React.memo(
    ({
        form,
        isModalOpened,
        setIsModalOpened,
        setIsAddClicked,
        setEditedData,
        isModalOpen,
        setIsModalOpen,
        setDataIsUpdated,
        dataModeInformation,
        associated,
        setIsSendingTag,
        dataTable,
        setIsAddModeOfInformationClicked,
        setLimit,
        KIOSKData,
        isModalModifiedOpened,
        setIsModalModifiedOpened,
        isAdvancedDisplayNameModalOpen,
        setIsAdvancedDisplayNameModalOpen,
        setAdvancedDisplayName,
        language,
        isConsult,
        isActionsClicked,
    }: Props) => {
        return (
            <>
                <ConfirmationEditMessage
                    isModalOpened={isModalOpened}
                    setIsModalOpened={setIsModalOpened}
                    setIsAddClicked={setIsAddClicked}
                    setEditedData={setEditedData}
                />

                {isModalOpen && (
                    <ConfirmationModificationMessage
                        isModalOpened={isModalOpen}
                        setIsModalOpened={setIsModalOpen}
                        setIsEdited={setIsEdited}
                        setDataIsUpdated={setDataIsUpdated}
                        dataModeInformation={dataModeInformation}
                        associated={associated}
                        setIsSendingTag={setIsSendingTag}
                        dataTable={dataTable}
                        setIsAddModeOfInformationClicked={
                            setIsAddModeOfInformationClicked
                        }
                        setLimit={setLimit}
                        KIOSKData={KIOSKData}
                    />
                )}

                {isModalModifiedOpened && (
                    <ConfirmationAssociationModal
                        isModalOpened={isModalModifiedOpened}
                        setIsModalOpened={setIsModalModifiedOpened}
                        setDataIsUpdated={setDataIsUpdated}
                        InformationMode={form.informationMode}
                        supportOfSale={form.supportOfSale}
                        modeOfSale={form.modeOfSale}
                        displayName={form.displayName}
                        tags={form.tagsData}
                        setIsSending={setIsSendingTag}
                        advancedDisplayName={form.advancedDisplayName}
                    />
                )}

                {isAdvancedDisplayNameModalOpen && (
                    <AdvancedDisplayNameModal
                        isConsult={isConsult}
                        isAdvancedDisplayNameModalOpen={
                            isAdvancedDisplayNameModalOpen
                        }
                        setIsAdvancedDisplayNameModalOpen={
                            setIsAdvancedDisplayNameModalOpen
                        }
                        setAdvancedDisplayName={setAdvancedDisplayName}
                        displayName={form.advancedDisplayName}
                        language={language}
                        isActionsClicked={isActionsClicked}
                        setActions={setActions}
                        setIsActionsClicked={setIsActionsClicked}
                        setIsEdited={setIsEdited}
                    />
                )}
            </>
        );
    }
);

InformationFormModals.displayName = "InformationFormModals";
export default InformationFormModals;
